"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_SEGMENT = void 0;
const react_1 = __importStar(require("react"));
const models_hook_1 = require("app/models.hook");
const route_1 = require("../route");
const schema_1 = __importDefault(require("./schema"));
const auth_1 = require("common/auth");
const firestore_web_1 = require("comodel/firestore-web");
const models_1 = require("app/models");
const firestore_1 = require("comodel/firestore");
const function_client_1 = require("@/utils/function-client");
const standard_1 = require("react-hook-schema/standard");
const standard_2 = require("react-hook-schema/standard");
const schemaComponents_1 = require("@/schemaComponents");
const components_1 = require("utils/components");
const bookParser_1 = require("@/utils/bookParser");
const helpers_1 = require("../helpers");
const index_1 = require("../../../../index");
const fileToBook_1 = require("../../../../../utils/fileToBook");
const api_1 = require("@/schemaComponents/modules/copilotApi/api");
// export const UPDATE_SEGMENT = SEGMENT.sub("/edit", Segment);
exports.ADD_SEGMENT = route_1.SEGMENTS.sub("/edit/new", Segment);
// Upload as Reference
// Any TRANSLATED texts should be treated as corrected state, and use them as reference translations.
// Upload as Worksheet
// Any TRANSLATED texts should have null or updated state (null for new rows, updated for updated ones).
const getTranslationStatus = ({ uploadMode, isNew, currentStatus, }) => {
    switch (uploadMode) {
        case "reference":
            return "corrected";
        case "worksheet":
            if (isNew) {
                return null;
            }
            return currentStatus === "corrected" ? currentStatus : "updated";
        default:
            return null;
    }
};
function Segment({ segmentId, projectId, }) {
    const alert = (0, standard_1.useAlert)();
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const { data, loading, set, isEditing } = (0, models_hook_1.useSegmentDoc)({
        segmentId,
        projectId,
    });
    const { data: projectData } = (0, models_hook_1.useProjectDoc)({ projectId });
    const { list: existingScriptList } = (0, models_hook_1.useReactiveScriptList)({
        projectId,
        segmentId,
    });
    const { list: langList } = (0, models_hook_1.useLangList)({ projectId });
    const langIds = (0, react_1.useMemo)(() => langList === null || langList === void 0 ? void 0 : langList.map((item) => item.langId), [langList]);
    const langAliases = (0, react_1.useMemo)(() => {
        return langList === null || langList === void 0 ? void 0 : langList.reduce((acc, item) => {
            acc[item.langId] = item.aliases || [];
            return acc;
        }, {});
    }, [langList]);
    const toast = (0, standard_1.useToast)();
    const errorModal = (0, standard_1.useErrorModal)();
    const parameter = {
        title: isEditing ? "翻訳ファイル詳細" : "翻訳ファイル新規作成",
        schema: (0, schema_1.default)({
            isEditing,
            projectId,
            segmentId,
            langAliases,
        }),
        edit: {
            title: `${isEditing ? "保存" : "保存"}`,
            confirm: `${isEditing ? "保存" : "保存"}しますか？`,
            handler: (data) => __awaiter(this, void 0, void 0, function* () {
                const { rawFiles, multiFile } = data, rest = __rest(data, ["rawFiles", "multiFile"]);
                const execute = (_a) => __awaiter(this, [_a], void 0, function* ({ rawFile, file, segmentName, }) {
                    var _b;
                    const _segmentId = data.segmentId || (0, firestore_1.getUniqueId)();
                    // MEMO: UploadOption should be a class with a constructor for validation
                    const uploadOption = {
                        ignoreLines: Math.max(0, Math.floor((_b = data.ignoreLines) !== null && _b !== void 0 ? _b : 2)),
                        scriptIdFormat: data.scriptIdFormat,
                        scriptTypeFormat: data.scriptTypeFormat,
                        translatedScriptFieldFormat: data.translatedScriptFieldFormat,
                        originalScriptField: data.originalScriptField,
                        columnsToSave: data.columnsToSave,
                        uploadMode: data.uploadMode,
                        langAliases: langAliases,
                    };
                    const bookParser = new bookParser_1.BookParser(uploadOption);
                    const book = yield (0, fileToBook_1.fileToBook)(rawFile);
                    const records = bookParser.parse(book);
                    if (!records || !langIds) {
                        return;
                    }
                    let naiveScripts = [];
                    const isUpdating = !!segmentId;
                    if (isUpdating) {
                        const uploadedScriptIds = records.map((record) => record.scriptId);
                        // in case of editing
                        // if script is removed (nonexistent in the uploaded script), remove the row in the DB.
                        naiveScripts =
                            (existingScriptList === null || existingScriptList === void 0 ? void 0 : existingScriptList.filter((script) => uploadedScriptIds.includes(script.scriptId))) || [];
                        const existingScriptIds = naiveScripts === null || naiveScripts === void 0 ? void 0 : naiveScripts.map((script) => script.scriptId);
                        records.forEach((record) => {
                            const { scriptId, text, translations } = record;
                            // case 1: no matched id
                            if (!(existingScriptIds === null || existingScriptIds === void 0 ? void 0 : existingScriptIds.includes(scriptId))) {
                                naiveScripts.push(Object.assign(Object.assign({}, record), { translationStatus: langIds === null || langIds === void 0 ? void 0 : langIds.reduce((acc, langId) => {
                                        acc[langId] = (translations === null || translations === void 0 ? void 0 : translations[langId])
                                            ? getTranslationStatus({
                                                uploadMode: data.uploadMode,
                                                isNew: true,
                                            })
                                            : null;
                                        return acc;
                                    }, {}) }));
                                return;
                            }
                            const existingScript = existingScriptList === null || existingScriptList === void 0 ? void 0 : existingScriptList.find((script) => script.scriptId === scriptId);
                            if (!existingScript)
                                return;
                            const isTextChanged = existingScript.text !== text;
                            // if the original text of uploaded row and the script differs
                            if (isTextChanged) {
                                // for each languages
                                for (const langId of langIds) {
                                    // 1. if translated text is present in the uploaded script,
                                    if (translations === null || translations === void 0 ? void 0 : translations[langId]) {
                                        // update the original text and translated text,
                                        // and update the status, also isTextUpdated set to true.
                                        naiveScripts = naiveScripts.map((script) => {
                                            var _a;
                                            return script.scriptId === existingScript.scriptId
                                                ? Object.assign(Object.assign({}, script), { text, translations: Object.assign(Object.assign({}, script.translations), { [langId]: translations[langId] }), translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: getTranslationStatus({
                                                            uploadMode: data.uploadMode,
                                                            isNew: false,
                                                            currentStatus: (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId],
                                                        }) }), isTextUpdated: true }) : script;
                                        });
                                    }
                                    else {
                                        // 2. if translated text is empty
                                        // update the original text, and set the status to "更新" (null), also isTextUpdated to true
                                        naiveScripts = naiveScripts.map((script) => script.scriptId === existingScript.scriptId
                                            ? Object.assign(Object.assign({}, script), { text, translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: null }), isTextUpdated: true }) : script);
                                    }
                                }
                            }
                            else {
                                // if the original text of uploaded row and the script is same
                                // for each languages
                                langIds === null || langIds === void 0 ? void 0 : langIds.forEach((langId) => {
                                    // translation is empty, then do nothing
                                    if (!(translations === null || translations === void 0 ? void 0 : translations[langId]))
                                        return;
                                    // if translation is updated, then update the translation, and update the status
                                    naiveScripts = naiveScripts.map((script) => {
                                        var _a;
                                        return script.scriptId === existingScript.scriptId
                                            ? Object.assign(Object.assign({}, script), { translations: Object.assign(Object.assign({}, script.translations), { [langId]: translations[langId] }), translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: getTranslationStatus({
                                                        uploadMode: data.uploadMode,
                                                        isNew: false,
                                                        currentStatus: (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId],
                                                    }) }) }) : script;
                                    });
                                });
                            }
                        });
                    }
                    else {
                        // in case of new
                        naiveScripts = records.map((record) => {
                            return Object.assign(Object.assign({}, record), { translationStatus: langIds === null || langIds === void 0 ? void 0 : langIds.reduce((acc, langId) => {
                                    var _a;
                                    acc[langId] = ((_a = record.translations) === null || _a === void 0 ? void 0 : _a[langId])
                                        ? getTranslationStatus({
                                            uploadMode: data.uploadMode,
                                            isNew: true,
                                        })
                                        : null;
                                    return acc;
                                }, {}) });
                        });
                    }
                    const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, { projectId, segmentId: _segmentId }, {
                        filter: { segmentId: _segmentId },
                    });
                    const preparedScripts = accessor
                        .prepareUpload(naiveScripts)
                        .map((record) => (Object.assign({}, record.data)));
                    yield (0, function_client_1.replaceSegmentSearchDocuments)({
                        projectId,
                        segmentId: _segmentId,
                        scripts: preparedScripts,
                        endpoint: (0, api_1.getApiEndPoint)(),
                    });
                    yield set(Object.assign(Object.assign({}, rest), { segmentName,
                        file, segmentId: _segmentId }));
                });
                if ((rawFiles === null || rawFiles === void 0 ? void 0 : rawFiles.length) === 0) {
                    // throw new Error("ファイルが選択されていません");
                }
                const uploadPromises = [];
                if (rawFiles && rawFiles.length > 0) {
                    rawFiles.forEach(({ file, fileName }, index) => {
                        uploadPromises.push(execute({
                            rawFile: file,
                            segmentName: fileName,
                            file: data.multiFile[index],
                        }));
                    });
                }
                try {
                    // すべてのPromiseを実行
                    yield Promise.all(uploadPromises);
                    toast({
                        message: "アップロードが完了しました",
                        duration: 10000,
                        type: "success",
                    });
                }
                catch (error) {
                    toast({
                        message: "アップロード中にエラーが発生しました",
                        duration: 10000,
                    });
                }
            }),
        },
        remove: isEditing
            ? {
                handler: () => __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield (0, helpers_1.deleteSegment)(data);
                    }
                    catch (e) {
                        errorModal({
                            error: e,
                            internalMessage: "Error delete segment",
                            userMessage: "ファイルの削除に失敗しました。",
                        });
                    }
                }),
            }
            : undefined,
        backPath: (0, index_1.resolveRoute)("LIST_SEGMENTS", { projectId }),
    };
    if (isProjectDataReady(projectData)) {
        return (react_1.default.createElement(schemaComponents_1.SchemaFormPage, { data: Object.assign(Object.assign({ createdAt: Date.now(), columnsToSave: projectData.columnsToSave }, projectData.upload), data), parameter: parameter, loading: isEditing && loading, header: react_1.default.createElement(standard_2.AdminLocaleSelector, { locales: projectData === null || projectData === void 0 ? void 0 : projectData.availableLocales }), editModeEnabled: true }));
    }
    else {
        return react_1.default.createElement(components_1.Loading, null);
    }
}
// projectData initially has only projectId, and later it will be updated with the data from the server
// createdAt is a required field, so we can use it to check if the data is ready
function isProjectDataReady(data) {
    return !!data.createdAt;
}
exports.default = Segment;
